import { Button } from "@progress/kendo-react-buttons";
import CustomModal from "../modals/CustomModal";
import { useAppSelector } from "../../redux/store";
import { useState } from "react";

interface CharacteristicsProps {
    prod_num: number;
}

export default function Characteristics(props: CharacteristicsProps) {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const token = useAppSelector(state => state.appState.token);
    const d_inv010 = useAppSelector(state => state.appState.d_inv010);

    return <><Button className="blueButton" onClick={() => setOpenModal(true)}>Caractéristiques</Button>
        {openModal && (<CustomModal title="Caractéristiques du produit" body={<iframe width={'100%'} height={'99%'} title="Caractéristiques du produit"
            src={`${process.env.REACT_APP_CHARACTERISTICS_URL}?ref=${props.prod_num}&readonly=${d_inv010.canModify ? "non" : "oui"}&mode=P&callFrom=iframe&x-authorization=${token.split(' ')[1]}`} />}
            onClose={() => setOpenModal(false)} width={'80%'} height={'80%'} />)}</>;
}